import { FC } from 'react';
import Layout from '@/components/layout/Layout';
import BookCardItem from '@/components/ui/book-card-item/BookCardItem';
import Pagination from '@/components/ui/pagination/Pagination';
import SectionTitleMenu from '@/components/ui/section-title-menu/SectionTitleMenu';
import PageHeadingSort from '@/components/ui/page-heading-sort/PageHeadingSort';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import { IBookPage, IBooksPageData } from '@/interfaces/booksPage.interface';

import { BOOKS_FOR_PAGE } from '@/helpers/variables';

export interface INew {
  books: IBookPage;
  sortingName: string;
  sortingUrl?: string | undefined;
}

const New: FC<INew> = ({ books, sortingName, sortingUrl }) => {
  const pagesCount = Math.ceil(books?.total_count / BOOKS_FOR_PAGE);

  //Seo block
  const SEO_TITLE = 'Новинки книг на сайте Куча книг.';
  const SEO_DESCRIPTION = 'Перечень новинок книг в электронной библиотеке Куча книг. У нас можно прочитать книги или скачать их.';
  const SEO_CANONICAL = '/new/books/';

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={useGetUrlPath()}>
      <Breadcrumbs pageName="Новинки" />

      <SectionTitleMenu extraClassName={'sectionTitleMenu_sort'}>
        <PageHeadingSort titleName="Новинки" sortingName={sortingName} url="/new/books/" extraClassName="pageHeading_plain" />
      </SectionTitleMenu>

      <div data-cards="list" className="cardsWrapper">
        {books.data && books.data.length > 0 ? (
          books.data.map((book: IBooksPageData) => (
            <BookCardItem createdAt={book.created_at} alias={book.alias} author={book.author} book={book.book} rating={book.rating} key={book.id} draft={book.draft} readOnline={book.read_online} retelling={!!book.retaling} />
          ))
        ) : (
          <div>Книги не найдены</div>
        )}
      </div>
      {sortingUrl ? <Pagination pagesCount={pagesCount ?? 0} postName={`new/books/${sortingUrl}/page=`} /> : <Pagination pagesCount={pagesCount ?? 0} postName="new/books/page=" />}
      {/* <Breadcrumbs pageName="Новинки" isBottom={true} /> */}
    </Layout>
  );
};

export default New;
